/* SUİ favourites: saved in the visitor's browser (no account needed) */
(function(){
  var K='sui-wl',root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var HEART='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.6-9.3-9.5C1.5 7.3 3.7 4 7.2 4c2.1 0 3.7 1.1 4.8 2.9C13.1 5.1 14.7 4 16.8 4c3.5 0 5.7 3.3 4.5 6.8-1.7 4.9-9.3 9.5-9.3 9.5z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
  function get(){try{var a=JSON.parse(localStorage.getItem(K)||'[]');return Array.isArray(a)?a.filter(function(x){return typeof x==='string'}):[]}catch(e){return[]}}
  function save(a){try{localStorage.setItem(K,JSON.stringify(a))}catch(e){}sync();document.dispatchEvent(new CustomEvent('sui:wl'))}
  function sync(){
    var a=get();
    document.querySelectorAll('[data-wl]').forEach(function(b){var on=a.indexOf(b.dataset.wl)>-1;b.classList.toggle('on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',(on?'Remove from favourites':'Save to favourites'))});
    document.querySelectorAll('.wl-n').forEach(function(n){n.textContent=a.length;n.hidden=!a.length});
    document.querySelectorAll('.ic-wl').forEach(function(l){l.setAttribute('aria-label','Favourites'+(a.length?', '+a.length+(a.length===1?' item':' items'):''))});
  }
  function toast(html){
    var el=document.querySelector('.sui-toast');
    if(!el){el=document.createElement('div');el.className='sui-toast';el.setAttribute('role','status');el.setAttribute('aria-live','polite');document.body.appendChild(el)}
    el.innerHTML=html;el.classList.remove('err');requestAnimationFrame(function(){el.classList.add('on')});
    clearTimeout(el._t);el._t=setTimeout(function(){el.classList.remove('on')},3000);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-wl]');if(!b)return;
    e.preventDefault();e.stopPropagation();
    var h=b.dataset.wl,a=get(),i=a.indexOf(h);
    if(i>-1)a.splice(i,1);else a.unshift(h);
    save(a);
    b.classList.remove('pop');void b.offsetWidth;b.classList.add('pop');
    if(i<0&&!document.querySelector('.wl-page')){
      var img=b.dataset.img?'<img src="'+b.dataset.img+'" alt="">':'';
      toast(img+'<div><b>Saved to favourites ♡</b><a href="'+root+'pages/wishlist">View favourites</a></div>');
    }
  });
  window.addEventListener('storage',function(e){if(e.key===K){sync();document.dispatchEvent(new CustomEvent('sui:wl'))}});
  /* heart next to Add to cart on product pages */
  function pdp(){
    var buy=document.querySelector('.pd-buy'),h=window.suiProduct;
    if(!buy||!h||buy.querySelector('[data-wl]'))return;
    var b=document.createElement('button');b.type='button';b.className='wl-btn wl-btn--pd';b.dataset.wl=h.handle;b.dataset.img=h.img||'';b.innerHTML=HEART;
    buy.appendChild(b);
  }
  window.suiWl={get:get,save:save,sync:sync,heart:HEART};
  function init(){pdp();sync()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
